<nav [class]="isNavCollapsed ? 'collapsed' : ''" *ngIf="isVisible" id="navigation">
  <a class="navbar-brand" (click)="collapse()">
    <img *ngIf="whitelabel" [src]="whitelabelURL + whitelabel + '/logo.png'" [alt]="whitelabel + ' Logo'">
    <app-svg *ngIf="!whitelabel" source="/cubos_logo_4c" id="logo" width="32"></app-svg>
  </a>

  <a class="navbar-collapsor" id="navbar_collapsor" (click)="collapse()">
    <app-svg source="icons/feather/chevron-left" width="24"></app-svg>
  </a>

  <ul class="navbar-nav main-nav">
    <li *ngIf="isStageTesting || isStageDev || isStageExperimental || isStageLocal">
      <span *ngIf="isStageTesting" class="testing" title="Testing">
        <app-svg source="icons/feather/alert-triangle" height="18"></app-svg>
        <span class="ps-2" i18n="@@StageTesting">Testing</span>
      </span>
      <span *ngIf="isStageDev" class="dev" title="Dev">
        <app-svg source="icons/feather/alert-octagon" height="18"></app-svg>
        <span class="ps-2" i18n="@@StageDev">Dev</span>
      </span>
      <span *ngIf="isStageExperimental" class="experimental" title="Experimental">
        <app-svg source="icons/feather/alert-circle" height="18"></app-svg>
        <span class="ps-2" i18n="@@StageExperimental">Experimental</span>
      </span>
      <span *ngIf="isStageLocal" class="local" title="Local">
        <app-svg source="icons/feather/coffee" height="18"></app-svg>
        <span class="ps-2" i18n="@@StageLocal">Local</span>
      </span>
    </li>

    <!-- Technical: nur Dashboard + Ladestationen -->
    <li *ngIf="isTechnical">
      <a class="nav-link" id="nav_dashboard_technical" aria-current="page" [routerLink]="['/technical']"
        [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }" (click)="collapse(true)">
        <app-svg source="icons/feather/home" height="18"></app-svg>
        <span class="ps-2" i18n="@@DasboardLink">Dashboard</span>
      </a>
    </li>
    <li *ngIf="isTechnical">
      <a class="nav-link" id="nav_chargingstations_technical" [routerLink]="['/technical/charging-stations']"
        [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: false }" (click)="collapse(true)">
        <app-svg source="icons/feather/charging-station" height="18"></app-svg>
        <span class="ps-2" i18n="@@ChargingStationLink">Ladestationen</span>
      </a>
    </li>
    <!-- Account: Dashboard + gleiche Einträge wie Customer, ohne Rechnungen -->
    <li *ngIf="isAccount">
      <a class="nav-link" id="nav_dashboard_account" aria-current="page" [routerLink]="['/account']"
        [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }" (click)="collapse(true)">
        <app-svg source="icons/feather/home" height="18"></app-svg>
        <span class="ps-2" i18n="@@DasboardLink">Dashboard</span>
      </a>
    </li>
    <li *ngIf="isAccount">
      <a class="nav-link" id="nav_chargingstatistics_account" [routerLink]="['/evaluation/charging-statistics']"
        [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: false }" (click)="collapse(true)">
        <app-svg source="icons/feather/bar-chart-2" height="18"></app-svg>
        <span class="ps-2" i18n="@@ChargingstatisticsLink">Ladestatistik</span>
      </a>
    </li>
    <li *ngIf="isAccount">
      <a class="nav-link" id="nav_charginghistory_account" [routerLink]="['/evaluation/transactions']"
        [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: false }" (click)="collapse(true)">
        <app-svg source="icons/feather/zap" height="18"></app-svg>
        <span class="ps-2" i18n="@@TransactionsLink">Ladevorgänge</span>
      </a>
    </li>
    <li *ngIf="isAccount">
      <a class="nav-link" id="nav_chargingstations_account" [routerLink]="['/chargingstations/summary']"
        [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: false }" (click)="collapse(true)">
        <app-svg source="icons/feather/charging-station" height="18"></app-svg>
        <span class="ps-2" i18n="@@ChargingStationLink">Ladestationen</span>
      </a>
    </li>
    <li *ngIf="isAccount">
      <a class="nav-link" id="nav_deliverynotes_account" [routerLink]="['/evaluation/delivery-notes']"
        [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: false }" (click)="collapse(true)">
        <app-svg source="icons/feather/file-text" height="18"></app-svg>
        <span class="ps-2" i18n="@@DeliveryNotesLink">Lieferscheine</span>
      </a>
    </li>
    <li *ngIf="isAccount && config?.isManageVisible && permissions?.navManage">
      <a class="nav-link" id="nav_pricings_account" [routerLink]="['/pricings']" [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: false }" (click)="collapse(true)">
        <app-svg source="icons/feather/tag" height="18"></app-svg>
        <span class="ps-2" i18n="@@PricingLink">Tarife</span>
      </a>
    </li>
    <li *ngIf="config?.isDashboardVisible && permissions?.navDashboard && !isTechnical && !isAccount">
      <a class="nav-link" id="nav_dashboard" aria-current="page" [routerLink]="['/']" [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: true }" (click)="collapse(true)">
        <app-svg source="icons/feather/home" height="18"></app-svg>
        <span class="ps-2" i18n="@@DasboardLink">Dashboard</span>
      </a>
    </li>
    <li *ngIf="config?.isSubscriptionSystemVisible">
      <a class="nav-link" id="nav_dashboard" aria-current="page" [routerLink]="['/operator']"
        [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }" (click)="collapse(true)">
        <app-svg source="icons/feather/home" height="18"></app-svg>
        <span class="ps-2" i18n="@@DasboardLink">Dashboard</span>
      </a>
    </li>

    <li *ngIf="!isTechnical && config?.isManageVisible && isBlackboxAvailable && !this.isProduction && !this.isRuhr && !this.isVfl && !this.isStihl && !this.isFunke">
      <a class="nav-link" [routerLink]="['/energy']" [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: false }" (click)="collapse(true)">
        <app-svg source="icons/feather/trending-up" height="18"></app-svg>
        <span class="ps-2" i18n="@@StatusNotificationsLink">CUBOS.Energy</span>
      </a>
    </li>

    <li *ngIf="!isAccount && config?.isManageVisible && permissions?.navManage && !this.isProduction && !this.isRuhr && !this.isVfl && !this.isStihl && !this.isFunke">
      <a class="nav-link" id="nav_pricings" [routerLink]="['/pricings']" [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: false }" (click)="collapse(true)">
        <app-svg source="icons/feather/tag" height="18"></app-svg>
        <span class="ps-2" i18n="@@PricingLink">Tarife</span>
      </a>
    </li>

    <li
      *ngIf="!isAccount && !isTechnical && (config?.isManageVisible && permissions?.navManage && !this.isProduction && !this.isRuhr && !this.isVfl && !this.isStihl && !this.isFunke || config && permissions && config?.isTransactionsOnlyVisible && !this.isProduction && !this.isRuhr && !this.isVfl && !this.isStihl && !this.isFunke)">
      <a class="nav-link" id="nav_invoices" [routerLink]="['/invoices']" [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: false }" (click)="collapse(true)">
        <app-svg source="icons/feather/file-letter" height="18"></app-svg>
        <span class="ps-2" i18n="@@InvoicesLink">Rechnungen</span>
      </a>
    </li>

    <!-- <li *ngIf="config?.isManageVisible && permissions?.navManage">
      <a class="nav-link" id="nav_paymentreceipts" [routerLink]="['/payment-receipts']" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: false }" (click)="collapse(true)">
        <app-svg source="icons/feather/bill" height="18"></app-svg>
        <span class="ps-2" i18n="@@PaymentReceiptsLink">Zahlungsbelege</span>
      </a>
    </li> -->

    <li
      *ngIf="!isTechnical && config?.isEvaluationVisible && permissions?.navEvaluation && !this.isProduction && !this.isRuhr && !this.isVfl && !this.isStihl && !this.isFunke">
      <a class="nav-link" id="nav_deliverynotes" [routerLink]="['/evaluation/delivery-notes']"
        [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: false }" (click)="collapse(true)">
        <app-svg source="icons/feather/file-text" height="18"></app-svg>
        <span class="ps-2" i18n="@@DeliveryNotesLink">Lieferscheine</span>
      </a>
    </li>

    <li
      *ngIf="!isTechnical && config && permissions && config?.isTransactionsOnlyVisible && !this.isProduction && !this.isRuhr && !this.isVfl && !this.isStihl && !this.isFunke">
      <a class="nav-link" id="nav_deliverynotes" [routerLink]="['/delivery-notes']" [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: false }" (click)="collapse(true)">
        <app-svg source="icons/feather/file-text" height="18"></app-svg>
        <span class="ps-2" i18n="@@DeliveryNotesLink">Lieferscheine</span>
      </a>
    </li>

    <li *ngIf="!this.isProduction && !isOperator && !isTechnical && !isAccount">
      <a class="nav-link" id="nav_chargingstatistics" [routerLink]="['evaluation/charging-statistics']"
        [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }" (click)="collapse(true)">
        <app-svg source="icons/feather/bar-chart-2" height="18"></app-svg>
        <span class="ps-2" i18n="@@ChargingstatisticsLink">Ladestatistik</span>
      </a>
    </li>

    <li *ngIf="!isTechnical && config?.isEvaluationVisible && permissions?.navEvaluation">
      <a class="nav-link" id="nav_charginghistory" [routerLink]="['/evaluation/transactions']"
        [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: false }" (click)="collapse(true)">
        <app-svg source="icons/feather/zap" height="18"></app-svg>
        <span class="ps-2" i18n="@@TransactionsLink">Ladevorgänge</span>
      </a>
    </li>

    <li *ngIf="!isTechnical && config?.isTransactionsOnlyVisible">
      <a class="nav-link" id="nav_charginghistory" [routerLink]="['/transactions']" [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: false }" (click)="collapse(true)">
        <app-svg source="icons/feather/zap" height="18"></app-svg>
        <span class="ps-2" i18n="@@TransactionsLink">Ladevorgänge</span>
      </a>
    </li>

    <li
      *ngIf="!isTechnical && (config?.isChargingStationsVisible && permissions?.navChargingstations || config?.isTransactionsOnlyVisible)">
      <a class="nav-link" id="nav_chargingstations" [routerLink]="['/chargingstations/summary']"
        [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: false }" (click)="collapse(true)">
        <app-svg source="icons/feather/charging-station" height="18"></app-svg>
        <span class="ps-2" i18n="@@ChargingStationLink">Ladestationen</span>
      </a>
    </li>

    <li *ngIf="config?.isSubscriptionSystemVisible">
      <a class="nav-link" id="nav_chargingstations" [routerLink]="['/allstations']" [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: false }" (click)="collapse(true)">
        <app-svg source="icons/feather/charging-station" height="18"></app-svg>
        <span class="ps-2" i18n="@@ChargingStationLink">Ladestationen</span>
      </a>
    </li>

    <li *ngIf="config?.isSubscriptionSystemVisible && !isSupporter">
      <a class="nav-link" id="nav_chargingstations_pool" [routerLink]="[pool]" [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: false }" (click)="collapse(true)">
        <app-svg source="icons/feather/charging-station-group" height="18"></app-svg>
        <span class="ps-2" i18n="@@ChargingStationLink">Ladestationspool</span>
      </a>
    </li>

    <li
      *ngIf="config?.isSubscriptionSystemVisible && !this.isProduction && !isSupporter && !this.isRuhr && !this.isVfl && !this.isStihl && !this.isFunke">
      <a class="nav-link" id="nav_blackboxes" [routerLink]="['/blackboxes']" [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: false }" (click)="collapse(true)">
        <app-svg source="icons/feather/cpu" height="18"></app-svg>
        <span class="ps-2" i18n="@@BlackboxesLink">Blackboxen</span>
      </a>
    </li>

    <li
      *ngIf="permissions?.chargingstationsGroups && config?.isManageVisible && permissions?.navManage && !this.isProduction && !this.isRuhr && !this.isVfl && !this.isStihl && !this.isFunke">
      <a class="nav-link" id="nav_chargingstationsgroups" [routerLink]="['/chargingstations/groups']"
        [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: false }" (click)="collapse(true)">
        <app-svg source="icons/feather/charging-station-group" height="18"></app-svg>
        <span class="ps-2" i18n="@@ChargingStationsGroupsLink">Ladegruppen</span>
      </a>
    </li>

    <li *ngIf="config?.isSubscriptionSystemVisible && !this.isProduction && !this.isRuhr && !this.isVfl && !this.isStihl && !this.isFunke">
      <a class="nav-link" id="nav_customers" [routerLink]="['/customer']" [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: false }" (click)="collapse(true)">
        <app-svg source="icons/feather/user" height="18"></app-svg>
        <span class="ps-2" i18n="@@CustomerLink">Kunden</span>
      </a>
    </li>

    <li *ngIf="config?.isSubscriptionSystemVisible && !this.isProduction && !this.isRuhr && !this.isVfl && !this.isStihl && !this.isFunke">
      <a class="nav-link" id="nav_users" [routerLink]="['/users']" [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: false }" (click)="collapse(true)">
        <app-svg source="icons/feather/users" height="18"></app-svg>
        <span class="ps-2" i18n="@@UsersLink">Benutzer</span>
      </a>
    </li>

    <li *ngIf="config?.isManageVisible && permissions?.navManage && !this.isProduction && !this.isRuhr && !this.isVfl && !this.isStihl && !this.isFunke">
      <a class="nav-link" id="nav_users" [routerLink]="['/manage/users']" [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: false }" (click)="collapse(true)">
        <app-svg source="icons/feather/users" height="18"></app-svg>
        <span class="ps-2" i18n="@@UsersManagmentLink">Benutzer</span>
      </a>
    </li>

    <li *ngIf="config?.isManageVisible && permissions?.navManage && !this.isProduction && !this.isRuhr && !this.isVfl && !this.isStihl && !this.isFunke">
      <a class="nav-link" id="nav_rfid_cards" [routerLink]="['/rfidcards']" [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: false }" (click)="collapse(true)">
        <app-svg source="icons/feather/rfid-card" height="18"></app-svg>
        <span class="ps-2" i18n="@@RfidCardsLink">RFID-Karten</span>
      </a>
    </li>

    <li
      *ngIf="config?.isSubscriptionSystemVisible && !this.isProduction && !isSupporte && !this.isRuhr && !this.isVfl && !this.isStihlr && !this.isFunke">
      <a class="nav-link" id="nav_csprofiles" [routerLink]="['/manufacturer']" [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: true }" (click)="collapse(true)">
        <app-svg source="icons/feather/zap" height="18"></app-svg>
        <span class="ps-2" i18n="@@ManufacturerLink">Hersteller</span>
      </a>
    </li>

    <li
      *ngIf="config?.isSubscriptionSystemVisible && !this.isProduction && !isSupporter && !this.isRuhr && !this.isVfl && !this.isStihl && !this.isFunke">
      <a class="nav-link" id="nav_csprofiles" [routerLink]="['/csprofiles']" [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: true }" (click)="collapse(true)">
        <app-svg source="icons/feather/box" height="18"></app-svg>
        <span class="ps-2" i18n="@@ChargingStationProfileLink">Ladepunktprofile</span>
      </a>
    </li>

    <li *ngIf="false && config?.isSubscriptionSystemVisible">
      <a class="nav-link" id="nav_subscription_system" [routerLink]="['/subscription-types']"
        [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }" (click)="collapse(true)">
        <app-svg source="icons/feather/check-square" height="18"></app-svg>
        <span class="ps-2" i18n="@@SubscriptionTypesLink">Abo-System</span>
      </a>
    </li>

    <li *ngIf="config?.isSubscriptionSystemVisible && !this.isProduction && !this.isRuhr && !this.isVfl && !this.isStihl && !this.isFunke">
      <a class="nav-link" id="nav_statusnavigation" [routerLink]="['/statusnotifications']"
        [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: false }" (click)="collapse(true)">
        <app-svg source="icons/feather/alert-triangle" height="18"></app-svg>
        <span class="ps-2" i18n="@@StatusNotificationsLink">Statusmeldungen</span>
      </a>
    </li>
  </ul>

  <ul class="navbar-nav mb-2">
    <li *ngIf="config?.isSubscriptionSystemVisible && !isSupporter">
      <a class="nav-link" id="nav_cubos_guide" href="http://guide.mycubos.com/" target="_blank"
        (click)="collapse(true)">
        <app-svg source="icons/feather/hexagon" height="18"></app-svg>
        <span class="ps-2" i18n="@@CUBOSGuideLink">CUBOS.Guide</span>
      </a>
    </li>

    <li *ngIf="config?.isProfileVisible && !this.isProduction && !this.isRuhr && !this.isVfl && !this.isStihl && !this.isFunke">
      <a class="nav-link" id="nav_profile" [routerLink]="['/profile']" [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: true }" (click)="collapse(true)">
        <app-svg source="icons/feather/settings" height="18"></app-svg>
        <span class="ps-2" i18n="@@ProfileLink">Profil</span>
      </a>
    </li>

    <li *ngIf="config?.isManageVisible && permissions?.navManage && !this.isProduction && !this.isRuhr && !this.isVfl && !this.isStihl && !this.isFunke ">
      <a class="nav-link" id="nav_profile" [routerLink]="['/profil']" [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: true }" (click)="collapse(true)">
        <app-svg source="icons/feather/user" height="18"></app-svg>
        <span class="ps-2" i18n="@@ProfileLink" *ngIf="isUserView && !isCustomerView">Profil</span>
        <span class="ps-2" i18n="@@AccountLink" *ngIf="isCustomerView">Profil</span>
      </a>
    </li>

    <!--<app-change-customer></app-change-customer>-->

    <li *ngIf="!config?.isSubscriptionSystemVisible">
      <a class="nav-link" id="nav_support" [routerLink]="['/support']" [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: true }" (click)="collapse(true)">
        <app-svg source="icons/feather/help-circle" height="18"></app-svg>
        <span class="ps-2" i18n="@@SupportLink">Support</span>
      </a>
    </li>

    <!-- <li *ngIf="!config?.isSubscriptionSystemVisible">
      <a class="nav-link" [routerLink]="['/upgrade']" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: true }" (click)="collapse(true)">
        <app-svg source="icons/feather/award" height="18"></app-svg>
        <span class="ps-2" i18n="@@UpgradeLink">Upgrade</span>
      </a>
    </li> -->

    <li>
      <a class="nav-link" id="nav_logout" [routerLink]="[]" (click)="logout()">
        <app-svg source="icons/feather/log-out" height="18"></app-svg>
        <span class="ps-2" i18n="@@LogoutLink">Abmelden</span>
      </a>
    </li>
  </ul>
</nav>

<a id="nav-toggler" (click)="collapse()" *ngIf="isVisible">
  <svg version="1.1" id="icon-menu" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px" y="0px" viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
    <path id="icon-menu-bottom" d="M26,24H4c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S26.6,24,26,24z" />
    <path id="icon-menu-middle" d="M26,16H4c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S26.6,16,26,16z" />
    <path id="icon-menu-top" d="M26,8H4C3.4,8,3,7.6,3,7s0.4-1,1-1h22c0.6,0,1,0.4,1,1S26.6,8,26,8z" />
    <path id="icon-menu-middle-hidden" d="M26,16H4c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S26.6,16,26,16z" />
  </svg>
</a>

<div *ngIf="isUserAuthenticated" id="qr-code-scan-overlay"
  class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
  [style.opacity]="qrAction?.isStart ? '1' : '0'" [ngClass]="qrAction?.isStart ? 'pe-auto' : 'pe-none'"
  (click)="closeQrScanner()">
  <div class="qr-code-scan-wrapper" (click)="$event.stopPropagation()">
    <ngx-scanner-qrcode #qrAction="scanner" class="qr-code-scanner" [isBeep]="false"
      [isAutoStart]="false"></ngx-scanner-qrcode>
  </div>
</div>

<a id="qr-scan-toggler" (click)="toggleQrScanner()" *ngIf="isVisible && (isUserAuthenticated)">
  <svg class="w-100 h-100" xmlns="http://www.w3.org/2000/svg" width="32" height="32" version="1.1" viewBox="0 0 32 32">
    <path
      d="M2.7,9.3V2.7h6.7v2.7h-4v4h-2.7ZM2.7,29.3v-6.7h2.7v4h4v2.7H2.7ZM22.7,29.3v-2.7h4v-4h2.7v6.7h-6.7ZM26.7,9.3v-4h-4v-2.7h6.7v6.7h-2.7ZM23.3,23.3h2v2h-2v-2ZM23.3,19.3h2v2h-2v-2ZM21.3,21.3h2v2h-2v-2ZM19.3,23.3h2v2h-2v-2ZM17.3,21.3h2v2h-2v-2ZM21.3,17.3h2v2h-2v-2ZM19.3,19.3h2v2h-2v-2ZM17.3,17.3h2v2h-2v-2ZM25.3,6.7v8h-8V6.7h8ZM14.7,17.3v8H6.7v-8h8ZM14.7,6.7v8H6.7V6.7h8ZM12.7,23.3v-4h-4v4h4ZM12.7,12.7v-4h-4v4h4ZM23.3,12.7v-4h-4v4h4Z"
      style="fill: #fff; stroke: none;" />
  </svg>
</a>
